
import { Vue, Component, Watch } from 'vue-property-decorator';
import { CompanyOutput } from '@fubonlife/tacallindiy-core-axios-sdk';
import InfoModal from "@/plugins/notification/infoModal";

interface CompanySelected {
	key: string,
	companyID: string,
	companyName: string,
	amount: string
}

@Component
export default class AnotherCompanyInsure extends Vue {
	form = {
		company: undefined,
		amount: ''
	}

	isLoadingSpin = false;

	companyOptions = []

	columns = [
		{ title: '保險公司名稱', dataIndex: 'companyName', key: 'companyName', align: 'center' },
		{ slots: { title: 'customTitle' }, dataIndex: 'amount', key: 'amount', align: 'center' },
		{ title: '', key: 'action', scopedSlots: { customRender: 'action' }, width: 100, align: 'center' },
	];

	validStatus: { [key: string]: string } = {
		company: '',
		amount: ''
	}

	customErrorMsg: { [key: string]: string } = {
		company: '',
		amount: ''
	}

	companyList: CompanySelected[] = [];

	isEdit = '';

	async created() {
		this.isLoadingSpin = true;
		await this.fetchCompany();
		this.isLoadingSpin = false;
		this.getCacheData();
	}

	async fetchCompany() {
		await this.$InformationControllerApi.getCompanyUsingGET1()
			.then(res => {
				if (res.status === 200) {
					const result: CompanyOutput = JSON.parse(JSON.stringify(res.data));
					if (result.processStatus.status === 'SUCCESS') {
						this.companyOptions = result.companys;
					} else {
						InfoModal.alertModal({
							alertType: "error",
							title: "錯誤",
							content: result.processStatus.message,
							customContent: null,
						});
					}
				} else {
					InfoModal.alertModal({
						alertType: "error",
						title: "錯誤",
						content: "保險公司取得失敗，請重新嘗試。",
						customContent: null,
					});
				}
			})
			.finally(() => {

			})
	}

	// 取緩存
	getCacheData(){
		const $params = this.$cache.getParam();
		if($params){
			this.companyList = $params.companyList;
		}
	}

	@Watch('companyList')
	companyListChange() {
		this.$emit('companyListChange', this.companyList);
	}


	// 手動觸發 antd FormModel 驗證
	triggerValidate(field: string, msg?: string) {
		if (msg) {
			this.validStatus[field] = "error";
			this.customErrorMsg[field] = msg;
		} else {
			this.validStatus[field] = "success";
			this.customErrorMsg[field] = "";
		}
	}

	// 前端檢核規則-必填
	checkRquired(value: string, requiredName: string) {
		if (!value) {
			return "請選擇" + requiredName;
		}
	}

	checkValidAmount(amount) {
		this.triggerValidate("amount", this.checkAmount(amount));
		if (this.validStatus.amount === "error") {
			return;
		}
	}

	// 前端檢核規則-驗證碼
	checkAmount(value: string) {
		if (!value) {
			return "請輸入保額";
		}
		if (!/^\+?[1-9][0-9]*$/g.test(value)) {
			return "請輸入正確保額";
		}
	}

	filterOption(input, option) {
		return (
			option.componentOptions.children[0].text
				.toLowerCase()
				.indexOf(input.toLowerCase()) >= 0
		);
	}

	handleInsert() {
		const companyHasError = this.checkRquired(this.form.company, "保險公司名稱");
		const amountHasError = this.checkAmount(this.form.amount);
		if (!companyHasError && !amountHasError) {
			var form = this.form;
			let editKey = this.isEdit;
			let company = this.companyOptions.find(e => e.companyID === form.company);
			if (editKey) {
				let companyBeChange = this.companyList.findIndex(e => e.key === editKey);
				Vue.set(this.companyList, companyBeChange, {
					key: editKey,
					companyID: company.companyID,
					amount: form.amount,
					companyName: company.companyName,
				});
				this.isEdit = '';
			} else {
				let company = this.companyOptions.find(e => e.companyID === form.company);
				let obj = {
					key: this.makeid(10),
					companyID: company.companyID,
					amount: form.amount,
					companyName: company.companyName,
				}
				this.companyList.push(obj)
			}
			this.clearForm();
		} else {
			this.triggerValidate("company", companyHasError);
			this.triggerValidate("amount", amountHasError);
		}
	}

	onEdit(record: CompanySelected) {
		this.isEdit = record.key;
		this.form.company = record.companyID;
		this.form.amount = record.amount;
	}

	onDelete(record: CompanySelected) {
		let index = this.companyList.findIndex(e => e.key === record.key);
		this.companyList.splice(index, index + 1);
	}

	clearForm() {
		this.form.company = undefined;
		this.form.amount = '';
	}

	makeid(length: number) {
		let result = '';
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		const charactersLength = characters.length;
		let counter = 0;
		while (counter < length) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
			counter += 1;
		}
		return result;
	}

	handleBeforeSubmit() {

	}

}
